import React, { Component } from 'react';
import {Link} from 'react-router-dom'
import firebase from '../Configs/firebase'

class MapsDroneLayerDetails extends Component {

    constructor(props){
        super(props)
        this.state = {
            isSaved: false
        }

        this.handleClose = this.handleClose.bind(this)
        this.handleSave = this.handleSave.bind(this)
        this.handleShare = this.handleShare.bind(this)

    }

    handleClose(){
        const {setCurrentPlan, setCurrentDroneLayer} = this.props
        setCurrentPlan(null)
        setCurrentDroneLayer(null)
    }

    handleSave(){
        const { droneLayer } = this.props;
        firebase.firestore().collection('drones').doc(droneLayer.uid).update({
            ['saved_uid.'+[firebase.auth().currentUser.uid]]:new Date()
        })
        .then(()=>{
            this.setState({
                isSaved:true
            })
        })
        .catch(err=>{
            console.log(err)
        })
    }

    handleShare(){
        this.props.setIsOpenShareDialog(true)
    }

    render() {
        const { droneLayer, isLoaded, user } = this.props;

        var leftButton = null
        var closeButton =   <div className="ListHeader">
                                <Link to={'/mymap'} replace>
                                    <div onClick={this.handleClose}> 
                                        <span className="CloseMenu"><i className="fas fa-times"></i></span>    
                                    </div>
                                </Link>
                            </div>

        if ( !isLoaded ) {
            return (
                <div className='MapsDetails box'>
                    <span className="MapsDetailsLoadingIcon icon is-medium">
                        <i className="fas fa-spinner fa-pulse fa-2x"></i>
                    </span>
                </div>
            );
        }
        else if ( droneLayer === undefined || droneLayer === null || droneLayer === false ) {
            return (
                <div className='MapsDetails box'>
                    <div className="content">
                        <div className="MapsDroneLayerHeader">
                            <h5 className="MapsDroneLayerName title has-text-white is-size-5">ไม่พบข้อมูล</h5>
                            <p className="MapsDroneLayerErrorDescription has-text-grey-light">The link you followed may be broken, or the page may have been removed.</p>
                        </div>
                    </div>
                </div>
            );
        }

        if ( user !== null &&  user !== undefined && ( droneLayer.userUid === user.uid || ( droneLayer.savedUid !== null && ( droneLayer.savedUid[user.uid] !== undefined && droneLayer.savedUid[user.uid].toDate() <= new Date() )))){
            leftButton =    <Link to={'/mymap'} replace> 
                                <button className="button is-primary is-rounded is-outlined share-and-save" onClick={this.handleEdit}>Add Layer</button>
                            </Link>                    
        }
        
        else if ( user !== null && user !== undefined && droneLayer.userUid !== user.uid && droneLayer.uid !== ""){
            leftButton = <button onClick={this.handleSave} className="button is-primary is-rounded is-outlined share-and-save">Save</button>
        }

        return (
            <div className='MapsDetails box'>
                <div className="content">
                    { closeButton }
                    <div className="MapsDroneLayerHeader">
                        <h5 className="MapsDroneLayerName title has-text-white is-size-5">{droneLayer.name}</h5>
                        <p className="MapsDroneLayerCreatedAt has-text-grey-light is-size-7">{droneLayer.createdAtString()}</p>
                        <p className="MapsDroneLayerCreatedAt has-text-grey-light is-size-7"> โดย {droneLayer.userName}</p>
                        <div className="is-max-width">
                            {leftButton}
                            <button className="button is-primary is-rounded share-and-save" onClick={this.handleShare}>Share</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default MapsDroneLayerDetails;


// WEBPACK FOOTER //
// ./src/PageMaps/_MapsDroneLayerDetails.js